module.exports = __webpack_public_path__ + "img/title.9c0cf09c.png";